package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.MERCHANT_FORGOT_PASSWORD
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class ForgotPasswordRequestModel(
    val email: String
) : BaseRequestModel(api = MERCHANT_FORGOT_PASSWORD)
